import isObject from 'lodash/isObject';

/**
 * Check if the error can be considered as an `Error` object.
 * @param error error thrown
 * @returns true if the error is a instance of the `Error` or it owns some basic error attributes
 */
export function isError(error: unknown): error is Error {
  const isErrorInstance = error instanceof Error;
  const ownsBasicErrorShape = isObject(error) && 'name' in error && 'message' in error;
  return isErrorInstance || ownsBasicErrorShape;
}
